import { render, staticRenderFns } from "./contract-trans-qrpay.vue?vue&type=template&id=666d9132&scoped=true"
import script from "./contract-trans-qrpay.vue?vue&type=script&lang=js"
export * from "./contract-trans-qrpay.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style-review.css?vue&type=style&index=0&id=666d9132&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666d9132",
  null
  
)

export default component.exports